<template>
	<div class="lh-homes">
		<div class="lh-culture-bg img" style="background-image:url(img/a7.jpg);"></div>
    	<div class="logo img"><img src="img/a2.png" /></div>
    	<ul class="lh-hostory-item clearfix lh-flex">
	    	<li><div data-music="img/audio/_01_01.mp3" data-page="2" data-text="战国时期，僰人聚居于现在的宜宾市境内，由于时常担任汉民族与西南少数名族的“通译”工作，因而熟悉并效仿中原及巴蜀酿酒之法。而僰人种植的
	“蒟”也是极好的酒曲原料，为僰人酿酒提供了物质基础。僰人有时作为贵族、豪强的奴仆，从事“家内劳动”，因此习于酿酒、善于酿酒。" @click="playMusic($event)"><router-link to="/xianqing" replace><img src="img/b1.png" /></router-link></div></li>
	        <li><div data-music="img/audio/_02_01.mp3" data-page="3" data-text="由于汉代推行牛耕、改良耕具和实行轮作，使粮食产量大增。且西汉时期宜宾成为四川盆地通往云贵高原的交通要道，频繁的政治、经济、文化交往，促
	进了酿酒业的发展。宜宾市范围内出土的各种铜制与陶制酒器从一定程度上证实了汉代宜宾酿酒业的发达，而从一些墓葬出土的岩画内容来看，以酒送迎
	往来，在东汉时的宜宾已经很普遍。" @click="playMusic($event)"><router-link to="/handai" replace><img src="img/b2.png" /></router-link></div></li>
	        <li><div data-music="img/audio/_03_01.mp3" data-page="4" data-text="唐代时期，宜宾政治、经济又有了新的发展，粮食产量也比汉代有了显著的提高。宜宾地区酒类众多，而其中又以“重碧春酒”最为著名，是当时的官酿名酒。诗圣杜甫曾在宴会上品尝到“春酒”，并赋诗一首为之赞美。" @click="playMusic($event)"><router-link to="/tangdai" replace><img src="img/b3.png" /></router-link></div></li>
	        <li><div data-music="img/audio/_04_01.mp3" data-page="5" data-text="宋代取消了五代时期严厉的酒禁，当时的农业进步使得人均粮食产量再创新高。同时宋代允许民间酿酒，对少数民族实施羁縻政策、开放边境贸易。如上
	四个原因使得宋代宜宾酒业空前发展。当时宜宾酿酒者多、酿酒量大，酒质也有提高，且出现了采用多种粮食作为酿酒原料的酿造方法，酒类繁多，以荔
	枝绿、姚子雪曲、春碧最为著名。黄庭坚曾写《安乐泉颂》赞颂“姚子雪曲”。宜宾当时的酒德酒风，达到了一个“诗、礼、雅”的高度。" @click="playMusic($event)"><router-link to="/songdai" replace><img src="img/b4.png" /></router-link></div></li>
	        <li><div data-music="img/audio/_05_01.mp3" data-page="6" data-text="明代时期，由于“劝农桑”“敦本业”政策的推行，粮食品类增加，产量上涨，宜宾酿酒呈现多种粮食混合酿酒的新特色，即酿造“杂粮酒”。当时包括宜宾城区以及宜宾周围地区的少数民族都有酿造杂粮酒的记录。" @click="playMusic($event)"><router-link to="/mingdai" replace><img src="img/b5.png" /></router-link></div></li>
	        <li><div data-music="img/audio/_06_01.mp3" data-page="7" data-text="清代初期，为了恢复受战乱影响的四川经济，清朝实行“移民实川”的政策，各省移民进入宜宾，既带来了一些先进的农业生产经验和优良农作物品种，同时也将外省的制曲、酿酒方法传播到了宜宾当地。康熙年间，陕籍烤酒师陈三的祖辈、首次确切地提出了以几种原料、按何种比例搭配、酿造杂粮酒的配方，经历五代的口口相传，最终传到陈三烤酒师手中，该配方被称为《陈氏秘方》。同治八年，陈三烤酒师在去世前，将秘方传给了爱徒赵铭盛，清末年间又由赵铭盛最终传给了五粮液传人邓子均。" @click="playMusic($event)"><router-link to="/qingdai" replace><img src="img/b6.png" /></router-link></div></li>
	    </ul>
	    <!-- <ul class="lh-hostory-item lh-flex">
	    	<li><div data-music="img/audio/_01_01.mp3" data-page="2" data-text="战国时期，僰人聚居于现在的宜宾市境内，由于时常担任汉民族与西南少数名族的“通译”工作，因而熟悉并效仿中原及巴蜀酿酒之法。而僰人种植的
	“蒟”也是极好的酒曲原料，为僰人酿酒提供了物质基础。僰人有时作为贵族、豪强的奴仆，从事“家内劳动”，因此习于酿酒、善于酿酒。" @click="playMusic($event)"><router-link to="/xianqing"><img src="img/b1.png" /></router-link></div></li>
	    </ul> -->
	    <div class="lh-hostory-cont" :class="on">
	    	<div><img src="img/qy.png" /></div>
	    </div>
	    <div class="lh-hostory-cont">
			<router-view></router-view>
	    </div>
    	<Footer :footerData="footerData"></Footer>
	</div>
</template>
<script type="text/javascript">
	import Footer from '@/components/Footer'
	//import {mapState} from 'vuex'
	export default{
		data(){
			return {
				footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:1,type:'culture'},
				on:''
			}
		},
		components:{
			Footer
		},
		computed:{
	      //...mapState(['username','count'])
	    },
	    mounted(e){
	    	if(this.$route.name !='hostory'){
	    		this.$router.replace({ path: 'hostory'})
	    	}
	    },
	    created(e){
	    	var that=this;
	    },
		methods:{
			playMusic(e){
				var that=this,music = $(e.currentTarget).data('music'),page = $(e.currentTarget).data('page'),text = $(e.currentTarget).data('text');
				if(page){
					that.footerData.page=page;
				}
				if(text){
					that.footerData.audioData.text=text;
				}
				if(music){
					var audio = $('#audio')[0];
					audio.src=music;
					audio.play();
					that.on='on';
					//that.playSetFooterData({icon:"icon-zanting"});
					that.footerData.audioData.icon="icon-zanting";
					//输出总时间
					audio.addEventListener('loadedmetadata',function(e){
						var duration = s_to_hs(Math.floor(audio.duration));
						//that.playSetFooterData({total:duration});
						that.footerData.audioData.total=duration;
					});
					//输出当前播放时间
					audio.addEventListener('timeupdate',function(e){
						var currentTime = audio.currentTime;
						var currentTime1=audio.currentTime.toFixed(2);
						//var currentTime=(this.currentTime/60).toFixed(2).toString().replace(/\./g,":");
						var currentTime=s_to_hs(Math.floor(currentTime));
						that.footerData.audioData.current=currentTime;
						var duration = audio.duration;
						var percentage = 100 * currentTime1/duration;
						//that.playSetFooterData({percentage:percentage});
						that.footerData.audioData.percentage=percentage;
					});
					function s_to_hs(s){
					    //计算分钟
					    //算法：将秒数除以60，然后下舍入，既得到分钟数
					    var h;
					    h  =   Math.floor((s/60));
					    //计算秒
					    //算法：取得秒%60的余数，既得到秒数
					    s  =   s%60;
					    //将变量转换为字符串
					    h    +=    '';
					    s    +=    '';
					    //如果只有一位数，前面增加一个0
					    h  =   (h.length==1)?'0'+h:h;
					    s  =   (s.length==1)?'0'+s:s;
					    return h+':'+s;
					}
					//播放完成
					audio.addEventListener('ended',function(e){
						//that.playSetFooterData({icon:"icon-bofang"});
						that.footerData.audioData.icon="icon-bofang";	
					});
				}
			}
		}
	}
</script>